import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";

export default function ProductSolucionesForm() {
  const { values, setFieldValue } = useFormikContext();

  // Initialize props structure for SOLUCIONES products
  useEffect(() => {
    if (!values.props || values.props.length === 0 || 
        !values.props.some(p => p?.key === "S" || p?.key === "U")) {
      const props = [
        { key: "S", value: "" }, // Especificacion
        { key: "U", value: "" }, // Unidad de medida
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.0.value"
          label="Especificación"
          as={TextField}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.1.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>
    </Grid>
  );
}

